import React, { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import moment from "moment";

//import {LeadFilterDataAPI, CallerAPI} from "./../../../API/Team/LeadAPI";
import {LeadFilterDataAPI, AssignLeadsToTeamAPI} from "./../../API/Sales/LeadAPI";
import Loader from "./../Loader";
import Paginate from "./../../utils/Pagination";
import ContentLoader from "./../../utils/ContentLoader";
//import { data } from "jquery";
import { ToastContainer } from 'react-toastify';
import { errorMesg } from "../Toaster";
import ReactSelect from 'react-select';
import { Offcanvas } from 'react-bootstrap';
import Layout from "./Layout";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";



const LeadFilter = () =>{

    const {filtertype} = useParams();
    const [searchParam] = useSearchParams();

    const [leads, setLeads] = useState([]);
    //const [showleads, setShowLeads] = useState(true);
    const [loading, setLoading] = useState(false);
    const [btnloader, setBtnLoader] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    const [callers, setCallers] = useState([]);
    const [callername, setCallerName] = useState("");
    const [leadids, setLeadIDs] = useState([]);
    //const [isleadassign, setIsLeadAssign] = useState(false);
    const [programs, setPrograms] = useState([]);
    const [institute, setInstitute] = useState([]);
    
    //const [selectedcallervalues, setSelectedCallerValues] = useState([]);
    //const [selectedcaller, setSelectedCaller] = useState([]);
    const [filterprogram, setFilterProgram] = useState("");
    const [filterinstitute, setFilterInstitute] = useState("");
    const [isleadfiltermodal, setIsLeadFilterModal] = useState(false);

    const [filterteam, setFilterTeam] = useState("");
    const [filterstage, setFilterStage] = useState([]);
    //const [filterdisposition, setFilterDisposition] = useState([]);
    //const [filtersubdisposition, setFilterSubDisposition] = useState([]);
    //const [filtercaller, setFilterCaller] = useState("");    
    //const [filtercontact, setFilterContact] = useState("");
    const [filtersStored, setFiltersStored] = useState(null);
    const [filtercampaign, setFilterCampaign] = useState(null);

    const [createdstartdate, setCreatedStartDate] = useState(null);
    const [createdenddate, setCreatedEndDate] = useState(null);

    const [selectedteam, setSelectedTeam] = useState(null);
    const [selectedteamvalue, setSelectedTeamValue] = useState(null);

    const [filtersource, setFilterSource] = useState([]);
    const [sources, setSources] = useState([]);

    const [teams, setTeams] = useState([]);
    const [stages, setStages] = useState([]);
    const [totalrecords, setTotalRecords] = useState(0);
    const [campaigns, setCampaigns] = useState([]);
    const [isleadassign, setIsLeadAssign] = useState(false);
        

    const [filtersDraft, setFiltersDraft] = useState({
                                                        /*filterteam: "",*/
                                                        filterstage: "",
                                                        /*filterdisposition: [],
                                                        filtersubdisposition: [],*/
                                                        filterprogram: "",
                                                        //filterinstitute: "",
                                                        /*filterdateoption: "",
                                                        filterstartdate: "",
                                                        filterenddate: "",
                                                        filtername: "",
                                                        filteremail: "",
                                                        filtercontact: "",
                                                        filtercaller: "",
                                                        filtersortby: "",
                                                        filtersortorder: "",*/
                                                        filtercreatedstartdate: "",
                                                        filtercreatedenddate: "",
                                                        /*filterassignedstartdate: "",
                                                        filterassignedenddate: "",
                                                        filterassignmenttype: "",*/
                                                        filtersource: "",
                                                        //filtercampaign: "",
                                                    });

    const perpagedata = 20;

    const filterparams = new URLSearchParams();
    

    useEffect(() => {

        //CallerAPI(setCallers);
    }, []);

    useEffect(() => {
        
        console.log("Step 1");

        /*if (!filtersStored)
        {
            console.log('Step 1.2');
            return;  
        }*/ 
                
        console.log("Step 2");
        const filterparams = new URLSearchParams();

        const teamId = searchParam.get('filterteam');

        if (teamId) 
        {
            filterparams.append('filterteamid', teamId);
        }
        
        
        if (filtersStored)
        {
            console.log("Step 3");
                
            Object.keys(filtersStored).forEach(key => {
                if (filtersStored[key]) {
                    filterparams.append(key, filtersStored[key]);
                }
            });
        }

        console.log("Step 4");

        filterparams.append("page", currentPage);
        filterparams.append("per_page", perpagedata);

        console.log("Parama>>>>>" + JSON.stringify(filterparams));

        console.log("Filter Type>>>>>" + JSON.stringify(filtertype));

        //LeadDataAPI(setLeads, setLoading, setShowLeads, currentPage, perpagedata, setPageCount, setStages, setPrograms, setInstitutes, setTeams, params, false, setTotalRecords, setSources, setCampaigns);

        LeadFilterDataAPI(setLeads, setLoading, currentPage, perpagedata, setPageCount, filtertype, filterparams, setPrograms, setStages, setSources, setTeams);

    }, [filtersStored, currentPage]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

        //setIsFilterPagination(true);

        //handleFilterLeads();
    }    

    const handleSelectLead = (lid) =>{
        if(leadids.includes(lid))
        {
            setLeadIDs(leadids.filter(item => item !== lid));
        }
        else
        {
            setLeadIDs([...leadids, lid]);
        }
    }

    const handleLeadFilterModal = () =>{
		setIsLeadFilterModal(!isleadfiltermodal);
	}

	const handleLeadFilterModalHide = () =>{
        setIsLeadFilterModal(false);
    }

    const handleResetFilter = (e) =>{
    
        setFilterStage("");
        //setFilterDisposition("");
        //setFilterSubDisposition("");
        setFilterProgram("");
        //setFilterInstitute("");
        //setDateFilterOption("");
        //setStartDate("");
        //setEndDate("");
        //setFilterName("");
        //setFilterEmail("");
        //setFilterContact("");
        //setFilterCaller("");
        setFilterTeam("");
        setCreatedStartDate("");
        setCreatedEndDate("");
        //setAssignedStartDate("");
        //setAssignedEndDate("");
        //setAssignmentType("");
        setFilterSource("");
        //setFilterCampaign("");

        setFiltersDraft({
                    filterstage: "",
                    //filterdisposition: "",
                    //filtersubdisposition: "",
                    filterprogram: "",
                    //filterinstitute: "",
                    //filterdateoption: "",
                    //filterstartdate: "",
                    //filterenddate: "",
                    //filteremail: "",
                    //filtername: "",
                    //filtercontact: "",
                    //filtercaller: "",
                    filterteam: "",
                    filtercreatedstartdate: "",
                    filtercreatedenddate: "",
                    //filterassignedstartdate: "",
                    //filterassignedenddate: "",
                    //filterassignmenttype: "",
                    filtersource: "",
                    //filtercampaign: "",
        });

        setFiltersStored(null);
        setCurrentPage(1);
        
        //LeadsAPI(setLeads, setLeadCount, setPayAmount, currentPage, perpagedata, setPageCount, setDataLoader, null);
        //LeadDataAPI(setLeads, setLoading, setShowLeads, currentPage, perpagedata, setPageCount, setStages, setPrograms, setInstitutes, setTeams, "", false, setTotalRecords, setSources, setCampaigns);

        LeadFilterDataAPI(setLeads, setLoading, currentPage, perpagedata, setPageCount, filtertype, filterparams, setPrograms, setStages, setSources, setTeams);
    }

    const handleFilterSource = (selsource) =>{
        console.log('Filter source====' + JSON.stringify(selsource));

        setFilterSource(selsource);

        if(selsource)
        {
            //let sourcevalue = selsource.map(sourcedatalist => sourcedatalist.value);
            let sourcevalue = selsource ? selsource.value : "";


            setFiltersDraft(prev => ({
                                ...prev,
                                filtersource: sourcevalue
                            }));
        }
    }

    const handleFilterCampaign = (selcampaign) =>{

        setFilterCampaign(selcampaign);
        
        if(selcampaign)
        {
            let campaignvalue = selcampaign ? selcampaign.value : "";

            setFiltersDraft(prev => ({
                            ...prev,
                            filtercampaign: campaignvalue
                        }));

        }
    }

    const handleCreatedDateRange = (crdates) => {
    
        console.log("Created Dates====" + crdates);

        if(!crdates || (!crdates[0] && !crdates[1]))
        {
            
            console.log("created false condition");
            setCreatedStartDate("");
            setCreatedEndDate("");

            setFiltersDraft(prev => ({
                                ...prev,
                                filtercreatedstartdate: "",
                                filtercreatedenddate: ""
                            }));
        }
        else
        {
            console.log("created true condition");

            const [crstartdate, crenddate] = crdates;

            setCreatedStartDate(crstartdate);
            setCreatedEndDate(crenddate);

            setFiltersDraft(prev => ({
                                ...prev,
                                filtercreatedstartdate: format(crstartdate, "yyyy-MM-dd"),
                                filtercreatedenddate: format(crenddate, "yyyy-MM-dd")
                            }));

        }

    }

    const handleFilterStage = (selstages) =>{
        console.log('Filter Stage=====' + JSON.stringify(selstages));

        setFilterStage(selstages);

        if(selstages)
        {
            //let stagevalue = selstages.map(sgdatalist => sgdatalist.value);
            let stagevalue = selstages ? selstages.value : "";

            console.log('Selected stage value======' + stagevalue);

            setFiltersDraft(prev => ({
                            ...prev,
                            filterstage: stagevalue
                        }));

            //getDispositionAPI(stagevalue, setDispositions);
        }

    }

    const handleFilterProgram = (selprogram) =>{
        console.log('Filter program====' + JSON.stringify(selprogram));

        setFilterProgram(selprogram);

        if(selprogram)
        {
            //let programvalue = selprogram.map(prgdatalist => prgdatalist.value);
            let programvalue = selprogram ? selprogram.value : "";


            setFiltersDraft(prev => ({
                                ...prev,
                                filterprogram: programvalue
                            }));
        }
    }

    const handleFilterInstitute = (selinstitute) =>{
        console.log('Filter institute====' + JSON.stringify(selinstitute));

        setFilterInstitute(selinstitute);

        if(selinstitute)
        {
            //let institutevalue = selinstitute.map(instdatalist => instdatalist.value);
            let institutevalue = selinstitute ? selinstitute.value : "";


            setFiltersDraft(prev => ({
                                ...prev,
                                filterinstitute: institutevalue
                            }));
        }
    }

    const handleApplyFilter = () =>{

        console.log('Filter Campaign====' + filtercampaign);
        console.log('Filter program====' + filterprogram);
        console.log('Filter source====' + filtersource);
        console.log('Filter institute====' + filterinstitute);
        //console.log('Filter created date====' + filtercreatedstartdate + '======' +filtercreatedenddate);

        setFiltersStored({
                            ...filtersDraft,
                            //page: 1
                        });

        setCurrentPage(1);

        setIsLeadFilterModal(false);
    }

    const handleChangeTeam = (selteamdata) =>{

        setSelectedTeam(selteamdata);

        if(selteamdata)
        {
            let teamid = selteamdata ? selteamdata.value : "";

            setSelectedTeamValue(teamid);

        }
        
    }

    const handleLeadAssign = (e) =>{
        e.preventDefault();

        console.log('leadids====' + leadids);
        console.log('team====' + selectedteamvalue);

        if(selectedteamvalue)
        {
            //let callerdata = selectedcaller.map(callerlist => callerlist.value);

            if(leadids.length > 0)
            {
                console.log('team id===' + selectedteamvalue);
                console.log('selected ids===' + leadids);

                const params = {
                                'team_id': selectedteamvalue,
                                'lead_ids': leadids
                            };

                //console.log('>>>>>>' + params);

                //return false;

                AssignLeadsToTeamAPI(params, setIsLeadAssign, setLoading);
            }
            else
            {
                errorMesg('Please select a lead to assign this team');
                return;
            }
        }
        else
        {
            errorMesg('Please select a team to assign selected leads');
            return;
        }
    }

    const handleSelectAllLeads = () =>{

        if(leadids.length === leads.length)
        {
            setLeadIDs([]);
        }
        else
        {
            setLeadIDs(leads.map(item => item.id));
        }
    }




    return(
    <Layout>
        <div className="content">

            <div className="row">
                <div className="col-md-12">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-12">
                                {filtertype === 'freshlead' ?
                                    <h4 className="page-title">Fresh Leads</h4>
                                :
                                    (filtertype === 'warmleads' ?
                                        <h4 className="page-title">Warm Leads</h4>
                                    :
                                        (filtertype === 'contactedleads' ?
                                            <h4 className="page-title">Contacted Leads</h4>
                                        :
                                            (filtertype === 'deadleads' ?
                                                <h4 className="page-title">Dead Leads</h4>
                                            :
                                                (filtertype === 'coldleads' ?
                                                    <h4 className="page-title">Cold Leads</h4>
                                                :
                                                    (filtertype === 'attemptleads' ?
                                                        <h4 className="page-title">Attempt to Contact Leads</h4>
                                                    :
                                                        (filtertype === 'enrolledleads' ?
                                                            <h4 className="page-title">Enrolled Leads</h4>
                                                        :
                                                            (filtertype === 'totalleads' ?
                                                                <h4 className="page-title">Total Leads</h4>
                                                            :
                                                                <></>    
                                                            )   
                                                        )   
                                                    )   
                                                )   
                                            )
                                        )
                                    )
                                }
                            </div>
                            
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="right">
                        <div className="row crm-filter-row-top align-items-center">

                            <div className="col-md-6 mb-1 d-flex align-items-center">
                                <button className="btn btn-success me-2" onClick={handleLeadFilterModal}>
                                    <i className="ti ti-filter me-2"></i> Filter
                                </button>

                                <button type="button" className="btn btn-dark" onClick={handleResetFilter}>
                                    <i className="fa fa-undo me-2"></i>Clear Filter
                                </button>
                            </div>

                            <div className="col-md-6 mb-1 d-flex justify-content-end align-items-center">

                                {filtertype === 'freshlead' &&
                                <>
                                    <div className="crm-caller-filter me-2">

                                        <ReactSelect className="me-1" value={selectedteam} onChange={handleChangeTeam} options={teams} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Team"></ReactSelect>

                                    </div>
                                    

                                    <div class="crm-filter-actions">
                                        <button type="button" className="btn btn-primary"  onClick={handleLeadAssign}>
                                            {btnloader ?
                                                <div className="spinner-border" role="status">
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                            :
                                                <p>Assign Lead</p>
                                            }
                                        </button>
                                    </div>
                                </>
                                }
                            </div>
                        </div>

                        <Offcanvas show={isleadfiltermodal} onHide={handleLeadFilterModalHide} placement="end" className="offcanvas-custom">
                            <Offcanvas.Header closeButton>
                                <Offcanvas.Title id="contained-modal-title-vcenter">Filter Leads</Offcanvas.Title>
                            </Offcanvas.Header>
                            <Offcanvas.Body>
                                <div class="row crm-filter-row-bottom align-items-end">
                                    {/*<div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Campaign</label>
                                        <ReactSelect className="" value={filtercampaign} onChange={handleFilterCampaign} options={campaigns} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Campaign"></ReactSelect>
                                    </div>
                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Team</label>
                                        <ReactSelect className="" value={filterteam} onChange={handleFilterTeam} options={teams} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Team"></ReactSelect>
                                    </div>
                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Caller</label>
                                        <ReactSelect className="" value={filtercaller} onChange={handleFilterCaller} options={callers} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Caller"></ReactSelect>
                                    </div>*/}

                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Program</label>
                                        <ReactSelect className="" value={filterprogram} onChange={handleFilterProgram} options={programs} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Program" ></ReactSelect>

                                    </div>

                                    {filtertype === 'warmleads' &&
                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Stage</label>
                                        <ReactSelect className="" value={filterstage} onChange={handleFilterStage} options={stages} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Stage"></ReactSelect>
                                    </div>
                                    }

                                    {/*<div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Disposition</label>
                                        <ReactSelect className="" value={filterdisposition} onChange={handleFilterDispositon} options={dispositions} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Disposition" isMulti></ReactSelect>
                                    </div>

                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Sub Disposition</label>
                                        <ReactSelect className="" value={filtersubdisposition} onChange={handleFilterSubDispositon} options={subdispositions} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select SubDisposition" isMulti></ReactSelect>
                                    </div>*/}

                                    
                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Source</label>
                                        <ReactSelect className="" value={filtersource} onChange={handleFilterSource} options={sources} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Source" ></ReactSelect>

                                    </div>
                                    {/*<div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Institute</label>
                                        <ReactSelect className="" value={filterinstitute} onChange={handleFilterInstitute} options={institute} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Institute" ></ReactSelect>

                                    </div>

                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Assignment Type</label>
                                        <ReactSelect className="" value={assignmenttype} onChange={handleFilterAssignmentType} options={assignmenttypelist} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Assignment Type"></ReactSelect>


                                    </div>

                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Assigned Date</label>
                                        <DatePicker  className="form-control" selected={assignedstartdate} onChange={ handleAssignedDateRange } startDate={assignedstartdate} endDate={assignedenddate} selectsRange isClearable placeholderText="Select assigned date range" />

                                    </div>*/}

                                    <div className="col-md-12 mb-1">
                                        <label class="crm-filter-label">Created Date</label>
                                        <DatePicker  className="form-control" selected={createdstartdate} onChange={ handleCreatedDateRange } startDate={createdstartdate} endDate={createdenddate} selectsRange isClearable placeholderText="Select created date range" />

                                    </div>


                                </div>                                

                                <div class="crm-filter-actions">
                                    <button type="button" class="btn btn-cancel" data-bs-dismiss="modal" onClick={handleLeadFilterModalHide}>Close</button>

                                    <button type="button" className="btn btn-primary me-2" onClick={handleApplyFilter}>
                                            <i className="ti ti-search me-2"></i>Apply Filter
                                    </button>

                                </div>
                            </Offcanvas.Body>

                        </Offcanvas>

                        
                    </div>
                </div>
                
                <div className="col-md-12">
                    <div className="card">

                        <div className="card-body">
                                                        
                            <div className="table-responsive table-wrapper">

                                {loading ?
                                
                                    <ContentLoader />
                                :
                                
                                    <table className="table table-data-section" id="">
                                        <thead className="thead-light">
                                            <tr>
                                                {filtertype === 'freshlead' &&
                                                <th>
                                                    <div class="form-check form-check-inline">
                                                        <input class="form-check-input" type="checkbox" id="flexCheckDefault" checked={leadids.length > 0 && leadids.length === leads.length} onChange={handleSelectAllLeads} />
                                                        <label class="form-check-label" for="flexCheckDefault"></label>
                                                    </div>
                                                </th>
                                                }

                                                <th className="sortable-column">Name</th>
                                                <th className="sortable-column">Email</th>
                                                <th className="sortable-column">Contact</th>
                                                <th className="sortable-column">Location</th>
                                                <th className="sortable-column">Program</th>
                                                <th className="sortable-column">Institute</th>
                                                <th className="sortable-column">Source</th>
                                                {filtertype === 'freshlead' ?
                                                <th className="sortable-column">Caller Name</th>
                                                :
                                                <th className="sortable-column">Lead Status</th>
                                                }                                                
                                                <th className="sortable-column">Created Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                    
                                        {
                                            (leads && leads.length > 0  ? 
                                                ( leads?.map(lead => 
                                                    (
                                            
                                                        <tr key={lead.id}>  
                                                            {filtertype === 'freshlead' &&                                                          
                                                            <td>
                                                                <div class="form-check form-check-inline">
                                                                    <input class="form-check-input" type="checkbox" id={'chkleaddata'+lead.id} checked={leadids.includes(lead.id)} onChange={() => handleSelectLead(lead.id)} />
                                                                    <label class="form-check-label" for={'chkleaddata'+lead.id}></label>
                                                                </div>
                                                            </td>
                                                            }

                                                            <td>
                                                                <Link to={`/sales/lead-profile/${lead.id}`} className="">
                                                                {lead.name}
                                                                </Link>
                                                            </td>
                                                            <td>{lead.email}</td>
                                                            <td>{lead.contact}</td>
                                                            <td>{lead.location}</td>
                                                            <td>{lead.program}</td>
                                                            <td>{lead.institute}</td>
                                                            <td>{lead.source}</td>

                                                            {filtertype === 'freshlead' ?
                                                            <td>{lead.callername}</td>
                                                            :
                                                            <td>
                                                                {lead.stagename !== "" && lead.stagename !== null ?
                                                                <span class="badge badge-tag badge-purple-light">{lead.stagename}</span>
                                                                :
                                                                    (lead.subdispositionname !== "" && lead.subdispositionname !== null ?
                                                                    <span class="badge badge-tag badge-purple-light">{lead.subdispositionname}</span>
                                                                    :
                                                                        (lead.dispositionname !== "" && lead.dispositionname !== null && lead.dispositionname !== null ?
                                                                        <span class="badge badge-tag badge-purple-light">{lead.dispositionname}</span>
                                                                        :                                                                        
                                                                        <></>   
                                                                        )
                                                                    )
                                                                }
                                                            </td>
                                                            }
                                                            <td>{moment(lead.created_at).format('DD-MM-YYYY h:mm')} </td>
                                                            
                                                        </tr>
                                                    )
                                                ))
                                            
                                            :
                                        
                                                null
                                            )
                                        }
                                    
                                        </tbody>
                                    </table>
                                }
                            </div>
                            
                            

                        </div>
                    </div>
                    
                    {pagecount > 1 ?
                    <div className="pagination-section mt-3">

                        <nav>
                            <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                        </nav>
                    </div>
                    :
                        <></>
                    }

                </div>
            </div>

        </div>
        

        <ToastContainer />

    </Layout>
    )
}

export default LeadFilter;